import { TextInput, SelectInput, PhoneNumberInput } from "components/form";
import useTranslate from "hooks/use-translate-language";
import { STATES } from "utils/enum";
import { useFormikContext } from "formik";

const EditPhysician = () => {
  const translate = useTranslate();
  const { values, errors } = useFormikContext();

  // Get physicians array from form values
  const physicians = values.physicians ?? [];

  return (
    <div>
      <h4>{translate("physicianInformation")}</h4>
      {physicians.map((physician, index) => (
        <div
          key={physician.product_line}
          style={{
            marginBottom: 30,
            padding: 20,
            border: "1px solid #ddd",
            borderRadius: 8
          }}
        >
          <h5 style={{ marginBottom: 15, color: "#666" }}>
            {physician.product_line} {translate("physician")}
          </h5>

          <TextInput
            label={translate("name")}
            name={`physicians.${index}.name`}
          />

          <div style={{ display: "flex", gap: "15px", flexWrap: "wrap" }}>
            <div style={{ flex: "1", minWidth: "200px" }}>
              <PhoneNumberInput
                label={translate("phoneNumber")}
                name={`physicians.${index}.phone`}
                type="tel"
              />
            </div>

            <div style={{ flex: "1", minWidth: "200px" }}>
              <PhoneNumberInput
                label={translate("faxNumber")}
                name={`physicians.${index}.fax`}
                type="tel"
              />
            </div>
          </div>

          <TextInput label="NPI" name={`physicians.${index}.npi`} />

          <div
            className="address-section"
            style={{
              marginTop: 10,
              padding: 15,
              backgroundColor: "#f8f9fa",
              borderRadius: 6
            }}
          >
            <h6
              style={{ marginBottom: 15, color: "#495057", fontWeight: "600" }}
            >
              {translate("address")}
            </h6>

            <div className="address-fields">
              <TextInput
                label={translate("streetAddress")}
                name={`physicians.${index}.address.street_address`}
              />

              <TextInput
                label={translate("streetAddress2")}
                name={`physicians.${index}.address.street_address2`}
              />

              <div style={{ display: "flex", gap: "15px", flexWrap: "wrap" }}>
                <div style={{ flex: "2", minWidth: "200px" }}>
                  <TextInput
                    label={translate("city")}
                    name={`physicians.${index}.address.city`}
                  />
                </div>

                <div style={{ flex: "1", minWidth: "120px" }}>
                  <SelectInput
                    label={translate("state")}
                    name={`physicians.${index}.address.state`}
                    options={STATES}
                  />
                </div>

                <div style={{ flex: "1", minWidth: "120px" }}>
                  <TextInput
                    label={translate("zip")}
                    name={`physicians.${index}.address.zip`}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default EditPhysician;
